<template>
  <div
    class="pa-4 full-height d-flex flex-column"
  >
    <v-card>
      <v-tabs
        centered
        grow
      >
        <v-tab
          v-for="(tab, i) in tabs"
          :key="i"
          :to="tab.to"
        >
          {{ tab.label }}
        </v-tab>
      </v-tabs>
    </v-card>

    <div
      class="mt-3"
      style="flex: 1;"
    >
      <v-layout
        v-if="$wait.is('loading posts')"
        justify-center
        align-center
        fill-height
        class="pt-12"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-layout>

      <router-view
        :style="{
          display: $wait.is('loading posts') ? 'none' : 'block',
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    tabs() {
      return [
        {
          label: 'Kuvat',
          to: '/admin/ilmiannot/kuvat',
        },
        {
          label: 'Kommentit',
          to: '/admin/ilmiannot/kommentit',
        },
      ];
    },
  },
};
</script>
